import { merge } from 'lodash'

// ////////////////////////////////////////////////////////////////////////// //
// Constants
// ////////////////////////////////////////////////////////////////////////// //
export const constants = {
  NAME: 'entities'
}

// ////////////////////////////////////////////////////////////////////////// //
// Selectors
// ////////////////////////////////////////////////////////////////////////// //
export const getUsers = (state) => state[constants.NAME].users
export const getAliadas = (state) => state[constants.NAME].aliadas
export const getServices = (state) => state[constants.NAME].services
export const getRecurrences = (state) => state[constants.NAME].recurrences

// ////////////////////////////////////////////////////////////////////////// //
// Reducer
// ////////////////////////////////////////////////////////////////////////// //
const initialState = {
  users: {},
  aliadas: {},
  recurrences: {},
  services: {}
}

export function reducer (state = initialState, action = {}) {
  if (action.payload && action.payload.entities) {
    return merge({}, state, action.payload.entities)
  }

  return state
}



// WEBPACK FOOTER //
// ./src/redux/modules/entities.js